import type { LucideIcon } from 'lucide-react';
import styles from './LockedSection.module.css';

export type LockedCtaColor = 'accent' | 'blue' | 'purple';

interface LockedSectionProps {
  icon: LucideIcon;
  headline: string;
  sub: string;
  cta?: string;
  ctaHref?: string;
  ctaColor?: LockedCtaColor;
  onCtaClick?: () => void;
}

export function LockedSection({
  icon: Icon,
  headline,
  sub,
  cta,
  ctaHref,
  ctaColor = 'accent',
  onCtaClick,
}: LockedSectionProps) {
  const handleClick = () => {
    if (onCtaClick) onCtaClick();
    else if (ctaHref) window.location.assign(ctaHref);
  };
  return (
    <div className={styles.root}>
      <div className={styles.body}>
        <span className={styles.icon}>
          <Icon size={24} strokeWidth={1.75} aria-hidden />
        </span>
        <div>
          <div className={styles.headline}>{headline}</div>
          <div className={styles.sub}>{sub}</div>
        </div>
      </div>
      {cta && (
        <button type="button" onClick={handleClick} className={`${styles.cta} ${styles[`cta_${ctaColor}`]}`}>
          {cta}
        </button>
      )}
    </div>
  );
}
